export default "__VITE_ASSET__3ee1e4d7__"